/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountPaymentStatusQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AccountPaymentStatusQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly paymentStatus: { readonly __typename?: 'AccountPaymentStatus', readonly isOkay: boolean, readonly stripeAction: { readonly __typename?: 'StripePaymentAction', readonly actionType: GraphQL.StripePaymentActionType, readonly clientSecret: string | null, readonly paymentMethod: string | null } | null } | null } | null };


export const AccountPaymentStatusDocument = gql`
    query AccountPaymentStatus($accountId: AccountId!) {
  account(id: $accountId) {
    id
    paymentStatus {
      isOkay
      stripeAction {
        actionType
        clientSecret
        paymentMethod
      }
    }
  }
}
    `;

/**
 * __useAccountPaymentStatusQuery__
 *
 * To run a query within a React component, call `useAccountPaymentStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountPaymentStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountPaymentStatusQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountPaymentStatusQuery(baseOptions: Apollo.QueryHookOptions<AccountPaymentStatusQuery, AccountPaymentStatusQueryVariables> & ({ variables: AccountPaymentStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountPaymentStatusQuery, AccountPaymentStatusQueryVariables>(AccountPaymentStatusDocument, options);
      }
export function useAccountPaymentStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountPaymentStatusQuery, AccountPaymentStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountPaymentStatusQuery, AccountPaymentStatusQueryVariables>(AccountPaymentStatusDocument, options);
        }
export function useAccountPaymentStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountPaymentStatusQuery, AccountPaymentStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountPaymentStatusQuery, AccountPaymentStatusQueryVariables>(AccountPaymentStatusDocument, options);
        }
export type AccountPaymentStatusQueryHookResult = ReturnType<typeof useAccountPaymentStatusQuery>;
export type AccountPaymentStatusLazyQueryHookResult = ReturnType<typeof useAccountPaymentStatusLazyQuery>;
export type AccountPaymentStatusSuspenseQueryHookResult = ReturnType<typeof useAccountPaymentStatusSuspenseQuery>;
export type AccountPaymentStatusQueryResult = Apollo.QueryResult<AccountPaymentStatusQuery, AccountPaymentStatusQueryVariables>;